import * as React from "react";
const SvgFiRrCowbellMore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12.67 21.89c-.21.08-.44.11-.67.11-1.1 0-2-.9-2-2h1c.55 0 1-.45 1-1s-.45-1-1-1H5c-.59 0-1.15-.26-1.53-.72-.38-.45-.54-1.05-.43-1.63l1.28-7.18C4.58 7.04 5.82 6 7.27 6h9.47c1.46 0 2.7 1.04 2.95 2.47l.66 3.7c.1.54.62.91 1.16.81s.91-.62.81-1.16l-.66-3.7a4.98 4.98 0 0 0-4.84-4.11c.11-.32.19-.65.19-1.01 0-1.65-1.35-3-3-3h-4c-1.65 0-3 1.35-3 3 0 .35.07.69.19 1.01a4.986 4.986 0 0 0-4.84 4.11L1.08 15.3c-.21 1.17.11 2.36.87 3.27S3.83 20 5.02 20h3a4 4 0 0 0 5.33 3.77 1.003 1.003 0 0 0-.67-1.89zM10 2h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1m14 17c0 .55-.45 1-1 1h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3h-3c-.55 0-1-.45-1-1s.45-1 1-1h3v-3c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1"
    />
  </svg>
);
export default SvgFiRrCowbellMore;
